import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;

`

export const ErrorMessage = styled.span`
    font-size: 12px;
    color: #f44336;

`